import { translate } from '@utils/i18n';
import AccountNameCell from './nested/AccountNameCell';

export const CACHE_KEY = 'kendo/accounts/index';

export const NAMESPACE = 'accounts.datatable';

export const INITIAL_PAGE_SKIP = 0;

export const INITIAL_PAGE = { skip: INITIAL_PAGE_SKIP, take: 25 };

export const INITIAL_SORT = [
  {
    field: 'name',
    dir: 'asc'
  }
];

export const INITIAL_FILTERS = {
  values: {
    name: '',
    status: 'true',
    tags: '',
    territory: '',
    additionalTerritory: '',
    salesPerson: ''
  },
  active: {
    name: true,
    status: true,
    tags: true,
    territory: true,
    additionalTerritory: false,
    salesPerson: true
  },
  operators: { name: 'contains' }
};

export const ALL_COLUMNS_DATA = {
  name: {
    id: 'name',
    field: 'name',
    title: translate('table.headers.name', { namespace: NAMESPACE }),
    cell: AccountNameCell,
    sortable: true
  },
  billing_address: {
    id: 'billing_address',
    field: 'billing_address',
    title: translate('table.headers.billing_address', { namespace: NAMESPACE }),
    sortable: true
  },
  number_of_buildings: {
    id: 'number_of_buildings',
    field: 'number_of_buildings',
    title: translate('table.headers.number_of_buildings', { namespace: NAMESPACE }),
    sortable: true,
    width: '250px'
  }
};

export const ALL_COLUMNS = Object.keys(ALL_COLUMNS_DATA);
